<template>
    <div class="list__header display--flex">
        <div class="list__header__content">
            <div class="list__header__destak">
                <span v-if="data.showId" class="list__header__id">
                    {{ data.id }}
                </span>
                {{ value }}
            </div>
        </div>
        <div class="list__header__actions">
            <template v-if="data.auditState" >
                <component
                    :is="data.auditState.component"
                    v-bind="{
                        ...properties
                    }"
                />
            </template>
            <router-link
                :to="`/${data.model || this.$route.name}/${data.id}`"
                class="list__header__actions__info position--relative display--inline-b accessibility--pseudo accessibility--active"
            >
                <icon-info class="list__header__actions__info__image" />
            </router-link>
        </div>
    </div>
</template>

<script>
// hooks
import getValue from '@/hooks/get-value';

// packages
import { ref } from '@vue/composition-api';

export default {
    components: {
        IconInfo: () => import( /* webpackChunkName: 'IconInfo' */ '@/components/bundles/layout/images/icons/IconInfo' )
    },
    props: {
        data: Object
    },
    setup ( props, { root: { $route } }) {
        // obtenção do valor.
        const { header, row } = props.data;

        const { value } = getValue( header, row, $route );
        let finalValue = Number;

        if ( props.data.auditState ) {
            // obtenção do valor state
            const stateValue = getValue( props.data.auditState.value, row, $route );

            finalValue = stateValue.value;
            // definção das propriedades do componente
        }

        const properties = ref({
            value: finalValue
        });

        return { value, properties };
    }
};
</script>